export const RESET_FILTRO_ENTITIES = 'RESET_FILTRO_ENTITIES';
export const CHANGE_FILTRO_ENTITIES_SELECCIONADO = 'CHANGE_FILTRO_ENTITIES_SELECCIONADO';
export const CHANGE_CONFIG_FILTRO_ENTITY = 'CHANGE_CONFIG_FILTRO_ENTITY';
export const SAVE_PROVINCIAS = 'SAVE_PROVINCIAS';
export const SAVE_MUNICIPIOS = 'SAVE_MUNICIPIOS';

const locations_municipios_cache = {}

export function changefiltroEntitySeleccionado(filtroEntitySeleccionado) {
    return (dispatch, getState) => {
        dispatch({
            type: CHANGE_FILTRO_ENTITIES_SELECCIONADO,
            payload: {filtroEntitySeleccionado: filtroEntitySeleccionado}
        });
    }
}

export function changeConfigFiltroEntity(configFiltroEntity) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_CONFIG_FILTRO_ENTITY, payload: {config: configFiltroEntity}});
    }
}


export function loadProvincias() {
    return (dispatch, getState) => {
        
        $.ajax({
                //Cambiar a type: POST si necesario
                type: "GET",
                //Datos que se envian
                data: {},
                // Formato de datos que se espera en la respuesta
                dataType: "json",
                // Asincronía.
                async: false,
                // URL a la que se enviará la solicitud Ajax
                url: "/api/config/locations/",
            })
            .done(function (data, textStatus, jqXHR) {
                dispatch({type: SAVE_PROVINCIAS, payload: {provincias: data}});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                //console.log("jqXHR = '" + JSON.stringify(jqXHR) + "'");
                //console.log("textStatus = '" + JSON.stringify(textStatus) + "'");
                //console.log("errorThrown = '" + JSON.stringify(errorThrown) + "'");
                
                
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                }
                
                if (console && console.log) {
                    console.log("La solicitud a fallado: " + errorStr);
                }
                
                
            });
    }
}

export function loadMunicipiosByProvincia(provincia) {
    //console.log("loadMunicipiosByProvincia::loadMunicipiosByProvincia()");
    
    return (dispatch, getState) => {
        if (locations_municipios_cache[provincia]) {
            dispatch({
                type: SAVE_MUNICIPIOS, payload: {
                    provincia: provincia,
                    municipios: locations_municipios_cache[provincia]
                }
            });
        } else {
            
            $.ajax({
                    //Cambiar a type: POST si necesario
                    type: "GET",
                    //Datos que se envian
                    data: {},
                    // Formato de datos que se espera en la respuesta
                    dataType: "json",
                    // Asincronía.
                    async: false,
                    // URL a la que se enviará la solicitud Ajax
                    url: "/api/config/locations/" + provincia,
                })
                .done(function (data, textStatus, jqXHR) {
                    locations_municipios_cache[provincia] = data
                    dispatch({
                        type: SAVE_MUNICIPIOS, payload: {
                            provincia: provincia,
                            municipios: data
                        }
                    });
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                        errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                    } else {
                        errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado :(";
                    }
                    
                    if (console && console.log) {
                        console.log("La solicitud a fallado: " + errorStr);
                    }
                });
        }
        
    }
}


export function resetFilterEntities() {
    //console.log("actionsFilterProtectora::resetFilterEntities()");
    return (dispatch, getState) => {
        dispatch({type: RESET_FILTRO_ENTITIES, payload: {}});
    }
}